(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6940],{

/***/ 55623:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities/[category]",
      function () {
        return __webpack_require__(75895);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_city_HybridElectricLandingPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5836);
/* harmony import */ var _src_components_city_VehicleLandingPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72411);
/* harmony import */ var _src_redux_actions_geolocation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47571);
/* harmony import */ var _src_utils_geolocation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53427);
/* harmony import */ var _src_utils_sanity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28669);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25631);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96981);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14416);








//export const config = { amp: true }  --  TODO: NEED TO TEST AMP SETTINGS TO GET AMP - Current Error "The attribute 'href' in tag 'link rel=stylesheet for fonts' is set to the invalid value '/static/nprogress.css'""





var Form = function(props) {
    var geolocation = props.geolocation;
    var masterProvider = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(function(state) {
        return state.masterProvider;
    });
    var phoneNumber = "(800)228-8379"; // TODO:  Move all Phone and Email to a Global Object Parsing ( )
    var googleNumber = "+18002288379";
    var emailAddress = "info@1800battery.com";
    if (masterProvider && masterProvider.isActive) {
        phoneNumber = masterProvider.phoneNumber ? masterProvider.phoneNumber : "";
        emailAddress = masterProvider.emailAddress ? masterProvider.emailAddress : "";
    }
    googleNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_9__/* .findPhoneNumbersInText */ .t)(phoneNumber, "US");
    if (googleNumber.length > 0) {
        googleNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_10__/* .parsePhoneNumber */ .S)(googleNumber[0].number.number);
        phoneNumber = googleNumber.formatNational();
        googleNumber = googleNumber.getURI();
    }
    var keywords = [];
    keywords.push((props.category ? props.category : "Vehicle") + " Battery");
    keywords.push(geolocation ? geolocation.formattedAddress : "Your City");
    keywords.push("Same Day Delivery");
    keywords.push("Professional Installation");
    keywords.push("National Warranty");
    keywords.push("Near Me");
    var hostname = "1800battery.com";
    if (true) {
        hostname = window.location.hostname;
    }
    var url = (props === null || props === void 0 ? void 0 : props.category) || "";
    var isManual = false;
    var myHref = isManual ? "/".concat(url) : "/category/[categoryid]?categoryid=".concat(url);
    var asVar = isManual ? url : "/category/".concat(url);
    var canonical = "https://".concat(hostname, "/cities/").concat(props.router.query.category);
    var target = url === "vehicle-batteries-hybrid-electric" ? "Hybrid Electric" : "Car/Automotive";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_6__/* .NextSeo */ .PB, {
                title: "".concat(target, " Battery Replacement & Install in ").concat((geolocation === null || geolocation === void 0 ? void 0 : geolocation.formatted_address) ? geolocation.formatted_address : "Your City"),
                description: "1-800-Battery offers mobile ".concat(target, " battery replacement services in ").concat((geolocation === null || geolocation === void 0 ? void 0 : geolocation.formatted_address) ? geolocation.formatted_address : "Your City", ". Make an appointment for your installation now."),
                canonical: canonical,
                keywords: keywords.join()
            }),
            url === "vehicle-batteries-hybrid-electric" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_city_HybridElectricLandingPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                CMSData: props.CMSData.page,
                phoneNumber: phoneNumber,
                geolocation: geolocation,
                myHref: "/category/vehicle-batteries-hybrid-electric",
                asVar: "/category/vehicle-batteries-hybrid-electric",
                googleNumber: googleNumber
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_city_VehicleLandingPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                CMSData: props.CMSData.page,
                phoneNumber: phoneNumber,
                geolocation: geolocation,
                myHref: "/category/vehicle-batteries-car-or-truck",
                asVar: "/category/vehicle-batteries-car-or-truck",
                googleNumber: googleNumber
            })
        ]
    });
};
Form.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(ctx) {
        var category, crit, geo, pageQuery, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    category = ctx.query.category;
                    crit = ctx.query.crit;
                    geo = null;
                    if (!ctx.store.getState().geolocation.latitude) return [
                        3,
                        1
                    ];
                    geo = ctx.store.getState().geolocation;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        (0,_src_utils_geolocation__WEBPACK_IMPORTED_MODULE_4__/* .fetchCritAndZip */ .Ic)(crit, true)
                    ];
                case 2:
                    geo = _state.sent();
                    _state.label = 3;
                case 3:
                    (0,_src_utils_geolocation__WEBPACK_IMPORTED_MODULE_4__/* .setLocation */ .l6)(geo);
                    ctx.store.dispatch(_src_redux_actions_geolocation__WEBPACK_IMPORTED_MODULE_3__/* .setLocation */ .l6(geo));
                    pageQuery = '*[_type == "landing" && slug.current == $slug] { slug, sections }';
                    return [
                        4,
                        _src_utils_sanity__WEBPACK_IMPORTED_MODULE_5__/* .sanity.fetch */ .P.fetch(pageQuery, {
                            slug: category
                        })
                    ];
                case 4:
                    data = _state.sent();
                    return [
                        2,
                        {
                            CMSData: data,
                            geolocation: geo,
                            category: category
                        }
                    ];
            }
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (Form);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,5675,1175,6672,7204,7206,8013,6865,5755,9774,2888,179], function() { return __webpack_exec__(55623); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);